import {
  SALES_CONTACT_EMAIL,
  SALES_CONTACT_SUBJECT_SUFFIX,
} from "./HelperFunction/Constants";

export const buildContactSalesMailto = ({ planTitle, name, email }) => {
  const subject = `${planTitle} ${SALES_CONTACT_SUBJECT_SUFFIX}`;
  const bodyLines = [
    "Hello,",
    "",
    `I am interested in the ${planTitle}.`,
    "",
    name ? `Name: ${name}` : null,
    email ? `Email: ${email}` : null,
  ].filter((line) => line !== null);

  return `mailto:${SALES_CONTACT_EMAIL}?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(bodyLines.join("\n"))}`;
};

export const getPlanExpiryText = (expiryDate) => {
  if (!expiryDate) {
    return "Current Plan";
  }

  const expiry = new Date(expiryDate);

  if (isNaN(expiry.getTime())) {
    return "Current Plan";
  }

  const now = new Date();

  if (expiry.getTime() <= now.getTime()) {
    return "Plan Expired";
  }

  // Compare calendar dates, not exact hours.
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const expiryDay = new Date(
    expiry.getFullYear(),
    expiry.getMonth(),
    expiry.getDate(),
  );

  const diffDays = Math.round(
    (expiryDay.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (diffDays > 1) {
    return `Expires in ${diffDays} days`;
  }

  if (diffDays === 1) {
    return "Expires in 1 day";
  }

  return "Expires today";
};

export const isCurrentPlan = (plan, currentPlanId) => {
  if (plan.isCustom) {
    return false;
  }

  if (!currentPlanId) {
    return plan.price === "Free" || plan.title.toLowerCase().includes("free");
  }

  const target = String(currentPlanId).toLowerCase();

  const planId = String(plan.id || "").toLowerCase();

  const planTitle = String(plan.title || "").toLowerCase();

  return target === planId || target === planTitle;
};

export const isFreePlan = (plan) => {
  if (!plan || plan.isCustom) {
    return false;
  }

  return (
    plan.price === "Free" ||
    plan.price === 0 ||
    plan.title?.toLowerCase().includes("free")
  );
};

export const formatPlan = (plan) => {
  const isCustom = plan.duration === "custom";

  return {
    id: plan._id,

    title: plan.planName || "Unnamed Plan",

    duration: plan.duration,

    isCustom,

    price: isCustom
      ? "Custom Pricing"
      : plan.price === 0
        ? "Free"
        : `${plan.price.toLocaleString()} PKR`,

    priceNote: isCustom ? "Pay per user" : "per month",

    description: plan.description || "",

    features: [
      ...(isCustom
        ? []
        : [
            `${plan.credits ?? 0} Credits per Month`,
            `${plan.userSeats ?? 1} User Seat`,
          ]),

      plan.clientMonitoring
        ? "Client Monitoring Available"
        : "No Client Monitoring",

      ...(plan.modules || []),
    ],

    buttonText: isCustom ? "Contact Us" : "Select Plan",
  };
};
